import { useMemo } from "react";
// @ts-ignore — AuthContext es JSX
import { useAuth } from "@/contexts/AuthContext";

export function useTeacherId(): { teacherId: string; teacherName: string } {
  const { user, profesorData, accessProfile } = useAuth();

  return useMemo(() => {
    const teacherName =
      profesorData?.nombreCompleto ||
      [profesorData?.nombre, profesorData?.apellido].filter(Boolean).join(" ").trim() ||
      accessProfile?.displayName ||
      user?.displayName ||
      "Profesor";

    return {
      teacherId: user?.uid ?? "",
      teacherName,
    };
  }, [user?.uid, user?.displayName, profesorData, accessProfile?.displayName]);
}
